import { useQuery } from "@tanstack/react-query";
import { env } from "@/env";
import { queryKeys } from "@/lib/query-keys";

export type InvitationPreview = {
  id: string;
  organizationId: string;
  email: string;
  role: string;
  status: "pending" | "accepted" | "rejected" | "cancelled";
  expiresAt: string;
  organization: {
    id: string;
    name: string | null;
    slug: string | null;
    logo: string | null;
  };
  inviter: {
    name: string | null;
    email: string | null;
  };
};

export function useInvitationPreview(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.organizations.invitationPreview(id),
    queryFn: async () => {
      const response = await fetch(`${env.VITE_API_URL}/api/invitations/${id}`);
      if (!response.ok) {
        throw new Error("Invitation not found");
      }
      return (await response.json()) as InvitationPreview;
    },
    enabled: !!id,
    retry: false,
  });
}
